export class AwsEc2AmiConvertResult {
    'imageId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "imageId",
            "baseName": "imageId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsEc2AmiConvertResult.attributeTypeMap;
    }
    constructor() {
    }
}
